import React from 'react';
import ReactDOM from 'react-dom/client';

// ORDEM IMPORTA — e é por isso que estes dois imports vêm ANTES do App.
//
// O Bootstrap e o Tailwind disputam os mesmos seletores de elemento (body, a,
// ul, button, h1...) com a MESMA especificidade. Nessa situação quem vence é
// quem for impresso por último no CSS final, ou seja: quem for importado
// depois. Como o site é Tailwind com o Bootstrap só de apoio, o Tailwind
// precisa vir por último — e ele entra junto com o App (App.js importa o
// App.css, que carrega @tailwind base).
//
// Até 18/08/2026 essa ordem era um acidente: o Faq.js importava o
// bootstrap.min.css uma segunda vez e era esse import que o puxava para o
// começo do arquivo. Quando a FAQ deixou de usar react-bootstrap, a ordem
// inverteu e o Bootstrap passou a pintar o fundo da página de branco e a
// sublinhar todos os links. Agora a ordem está declarada aqui, de propósito.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import App from './App';
import { initTheme } from './theme';

// Aplica o tema (claro/escuro) salvo antes do primeiro render
initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
